import {
  MEMBER_AUTH_LOADED,
  MEMBER_STATUS_UPDATE_RECEIVED
} from "WebsiteApp/modules/auth/AuthActions";
import { filterValidCards } from "./CardUtils";

export function cards(state = [], action) {
  switch (action.type) {
    case MEMBER_AUTH_LOADED:
      return filterValidCards(action.payload.cards || state);
    // return action.payload.cards || [];
    case MEMBER_STATUS_UPDATE_RECEIVED:
      let cards = state ? [...state] : [];
      let updatedBalances = action.payload.cards;
      updatedBalances.forEach(card => {
        cards.map(x => {
          if (x.id == card.id) {
            x.balance = card.balance;
            x.status = card.status;
            x.statusText = card.statusText;
          }
        });
      });

      return filterValidCards(cards);
  }
  return state;
}

export default cards;



// WEBPACK FOOTER //
// ./src/modules/card/CardReducers.js